import ContactForm from "../molecules/ContactForm";

const ContactSection = () => (
  <section className="min-h-screen pt-[10vh] flex items-center justify-center">
    <ContactForm />
  </section>
);

export default ContactSection;
